import { helper } from '@ember/component/helper'
import { roundAccurately } from 'teacher-ui-client/utils/round'

/**
 * Rounds a value to given decimal points using the round util. Does not pad with extra zero's to meet dp value.
 *
 * Usage:
 * {{round value}}
 * {{round value dp=2}}
 */

interface Signature {
  Args: {
    Positional: [number]
    Named: {
      /**
       * An optional positive whole number
       */
      dp?: number
    }
  }
  Return: number
}

export const round = helper<Signature>(function ([value], { dp }) {
  return roundAccurately(value, dp)
})

export default round
